import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import { invalidateUrl } from '@appbase/util'

@Component({
})
export default class ReadBody extends Vue {
  //
  // ────────────────────────────────────────────────── I ──────────
  //   :::::: P R O P S : :  :   :    :     :        :          :
  // ────────────────────────────────────────────────────────────
  //

  @Prop({ type: String }) id!: string

  //
  // ──────────────────────────────────────────────────────── I ──────────
  //   :::::: C O M P U T E D : :  :   :    :     :        :          :
  // ──────────────────────────────────────────────────────────────────
  //

  get url(): string {
    const escapedId = encodeURIComponent(this.id)
    const url = location.origin + `/cm/api/ews/body/html?id=${escapedId}`;
    return url
  }
} 
